import React, { useState } from 'react';
import api from '../../api/axios';

const RegisterAdminModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({ username: '', email: '', password: '', competitionName: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const token = localStorage.getItem('token'); // Recupera el token del localStorage
            if (!token) {
                alert('No tienes permisos para realizar esta acción.');
                setLoading(false);
                return;
            }

            // Envía los datos, incluyendo el "competitionName" (slug)
            await api.post(
                '/admin/users',
                { 
                    ...formData, 
                    role: 'Administrador', 
                    slug: formData.competitionName // Enviamos el nombre de la competencia como slug
                },
                { headers: { Authorization: `Bearer ${token}` } } // Agrega el token en los encabezados
            );
            alert('Administrador registrado con éxito');
            onClose();
        } catch (error) {
            console.error('Error al registrar administrador:', error.response?.data || error.message);
            alert(error.response?.data?.message || 'No se pudo registrar el administrador.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Registrar Nuevo Administrador</h2>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label>Usuario:</label>
                        <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <label>Email:</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <label>Contraseña:</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <label>Nombre de la Competencia (Slug):</label>
                        <input
                            type="text"
                            name="competitionName"
                            value={formData.competitionName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Registrando...' : 'Registrar'}
                    </button>
                    <button type="button" onClick={onClose}>
                        Cancelar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default RegisterAdminModal;


